import { render } from "./Project.vue?vue&type=template&id=774c4afe&scoped=true"
import script from "./Project.vue?vue&type=script&lang=js"
export * from "./Project.vue?vue&type=script&lang=js"

import "./Project.vue?vue&type=style&index=0&id=774c4afe&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-774c4afe"]])

export default __exports__